import { ColumnType } from "antd/es/table/interface";
import { PermissionEnum } from "types/enums.ts";
import { DrawerId, Identifiable, NonIdentifiable, TableId } from "types/models.ts";

import { FilterType } from "./filter";

import PageRequest = App.Http.Requests.PageRequest;
import FilterRequest = App.Http.Requests.FilterRequest;

export interface TableState<T extends Identifiable | NonIdentifiable> {
    id: TableId;
    editingRowId: string | null;
    config: TableLocalStorageConfig<T>; //config saved in local storage (visible columns and order of columns
    columns: TableColumnType<T>[] | null; //columns modified by order and visibility
    originColumns: TableColumnType<T>[] | null; //original columns config
    page: TablePageRequest; //pagination
    filter: FilterRequest;
    showOptionsFilter: boolean;
    showColumnsVisibility: boolean;
    initialized: boolean;
    timeFilterEnabled: boolean; //whether the table renders the TimeFilter — gates the global timeFilterAtom from leaking into this table's filters
}

export interface TablePageRequest extends PageRequest {
    size?: PageSize;
}

export enum PageSize {
    Five = 5,
    Ten = 10,
    Thirty = 30,
    OneHundred = 100,
}

export interface TableColumnType<T> extends ColumnType<T> {
    dataIndex: string | string[] | number;
    editable?: boolean;
    filterable?: boolean;
    filterType?: FilterType;
    filterOptions?: { label: string; value: string | number | boolean }[];
    filterName?: string;
    inputType?: string;
    visible?: boolean;
    order?: number;
    //showSorterTooltip?: boolean | { target: string };
    defaultSorter?: boolean;
    defaultSortOrder?: "ascend" | "descend";
}

export interface TableLocalStorageConfig<T> {
    columnsConfig: TableColumnType<T>[];
}

export interface TableUrlParameters {
    page?: PageRequest;
    filter?: FilterRequest;
    sort?: string;
}

// Define action type
type ActionType = "detail" | "drawer" | "edit" | "delete" | "custom" | "customButton";

interface DrawerAction<T> {
    to?: (record: T) => string | string;
    search?: (record: T) => { [x: string]: string };
    drawerId: DrawerId;
    disabled?: boolean;
}

// Define action interface
export interface TableAction<T extends Identifiable | NonIdentifiable> {
    type: ActionType;
    label?: string | React.ReactNode | ((record: T) => React.ReactNode);
    icon?: React.ReactNode;
    onClick?: (record: T) => void;
    link?: string;
    addToLink?: string;
    drawer?: DrawerAction<T>;
    visible?: (record: T) => boolean;
    permission?: PermissionEnum;
}
